import React from "react";
import { ImagePaths } from "teacherDashboard/teacher/config/class_left_nav_container/common";
import "./styles.scss";

const CircleAnimation = () => <div className="circle-animation"> <img src={ImagePaths.loaderGif}/> </div>

export default CircleAnimation